import type { Locale } from './types'
export default async function getMessages(locale: Locale): Promise<IntlMessages> {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
  const mod = (await import(`@betterplace/locales/messages/org/${locale}.json`, { with: { type: 'json' } })) as {
    default: IntlMessages
  }
  return mod.default
}
